import ArrowIcon from '../../../images/arrow-left-icon.svg';

import './SubscriptionStepCard.scss';

const SubscriptionStepCard = ({
  stepNumber,
  title,
  description,
  onBack = null,
  children,
  className = '',
}) => (
  <section className={`SubscriptionStepCard ${className}`.trim()}>
    <header className="SubscriptionStepCard__header">
      <div className="SubscriptionStepCard__header-main">
        <div className="SubscriptionStepCard__badge">{stepNumber}</div>
        <div className="SubscriptionStepCard__heading">
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>
      {!!onBack && (
        <button
          type="button"
          className="SubscriptionStepCard__back"
          onClick={onBack}
          aria-label="Back"
        >
          <img src={ArrowIcon} alt="" />
        </button>
      )}
    </header>
    <div className="SubscriptionStepCard__content">
      {children}
    </div>
  </section>
);

export default SubscriptionStepCard;
